var _path, _path2, _polygon, _polygon2, _path3, _path4, _polygon3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.98 19.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.44,0h1.34l5.81,19.72H17.24Zm6.84,16.36L22.93.08h1.29L18.67,19.43ZM7.08,19.72H5.66L0,0H1.26Z",
    fill: "#1c1c1c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.41,0h6.78C60.53,0,64,4,64,10.23a9.66,9.66,0,0,1-2.65,7.17c-1.67,1.61-3.75,2.32-7,2.32H48.41Zm1.34,1.18V18.49h4.76c2.79,0,4.51-.6,5.91-2a9,9,0,0,0,2.19-6.37,9.73,9.73,0,0,0-2.33-6.86,7.51,7.51,0,0,0-5.66-2Z",
    fill: "#1c1c1c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "94.01 19.72 92.64 19.72 85.81 0 87.06 0 93.3 17.94 94.01 19.72",
    fill: "#1c1c1c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.84 16.36 99.48 0 100.77 0 94.11 19.43 93.84 16.36",
    fill: "#00ada4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.19,9.1c2.92-.11,4.82-1.67,4.82-4s-2-4-4.57-4h-6.67v18.6h-1.34V0h8c3.5,0,5.91,2.08,5.91,5.12a4.7,4.7,0,0,1-1.75,3.69A5.7,5.7,0,0,1,115.08,10l4.9,9.68h-1.34l-4.84-9.46Z",
    fill: "#1c1c1c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76,9.1c2.93-.11,4.82-1.67,4.82-4s-2-4-4.56-4H69.54v18.6H68.2V0h8c3.5,0,5.9,2.08,5.9,5.12a4.7,4.7,0,0,1-1.75,3.69A5.65,5.65,0,0,1,77.86,10l4.89,9.68H81.41l-4.84-9.46Z",
    fill: "#1c1c1c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.78 16.36 11.29 0.56 11.71 3.56 7.17 19.43 6.78 16.36",
    fill: "#1c1c1c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.14,16.36V0h1.34V19.43Zm1.34,3.36H41.81L30.1,1.48V19.72H28.79V0h1.86L42.14,17.94Z",
    fill: "#1c1c1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.778048c977f3913e2763995fc5c9dd8c.svg";
export { ForwardRef as ReactComponent };